import type React from 'react';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';

import { StyledDropdownOption } from '../../../../../components/Dropdown/styles';
import { ALL_CATEGORY } from '../../../../../domain/salesforceActivity';

import { StyledCategoryFilterContainer, StyledCategoryFilterButton, StyledCategoryFilterDropdown } from './styles';

type Props = {
  categories: readonly string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
};

const getCategoryLabel = (category: string, allLabel: string): string =>
  category === ALL_CATEGORY ? allLabel : category;

export const CategoryFilter: React.FC<Props> = ({ categories, selectedCategory, onCategoryChange }) => {
  const { t } = useTranslation();
  const [isOpened, setIsOpened] = useState(false);

  const allLabel = t('company.salesforce_activity.category.all');

  const handleSelect = (category: string) => {
    onCategoryChange(category);
    setIsOpened(false);
  };

  return (
    <StyledCategoryFilterContainer data-automation="SalesforceActivityCategoryFilter">
      <StyledCategoryFilterButton
        onClick={() => setIsOpened(true)}
        isActive={isOpened}
        isSelected={selectedCategory !== ALL_CATEGORY}
        data-automation="SalesforceActivityCategoryFilterButton"
      >
        {getCategoryLabel(selectedCategory, allLabel)}
        <SWReactIcons iconName={isOpened ? 'chev-up' : 'chev-down'} size="xs" />
      </StyledCategoryFilterButton>
      <StyledCategoryFilterDropdown
        isOpened={isOpened}
        onClose={() => setIsOpened(false)}
        data-automation="SalesforceActivityCategoryFilterDropdown"
      >
        {categories.map((category) => (
          <StyledDropdownOption
            key={category}
            isSelected={selectedCategory === category}
            onClick={() => handleSelect(category)}
          >
            {getCategoryLabel(category, allLabel)}
          </StyledDropdownOption>
        ))}
      </StyledCategoryFilterDropdown>
    </StyledCategoryFilterContainer>
  );
};
